export var ChannelMethod = /*#__PURE__*/function (ChannelMethod) {
  ChannelMethod["mobile"] = "mobile";
  ChannelMethod["direct"] = "direct";
  ChannelMethod["email"] = "email";
  return ChannelMethod;
}({});
export var TemplateType = /*#__PURE__*/function (TemplateType) {
  TemplateType["Approval"] = "STAFF_ADDS_APPROVAL";
  TemplateType["Request"] = "STAFF_ADDS_REQUEST_WITH_DUE_DATE";
  TemplateType["Send"] = "STAFF_SENDS_DOCUMENT_LINKS";
  return TemplateType;
}({});
